import produce from 'immer';

export const initialState = {
  naverBatchStatusUpdateLoading: false,
  naverBatchStatusUpdateDone: false,
  naverBatchStatusUpdateData: null,
  pixelStatusUpdateLoading: false,
  pixelStatusUpdateDone: false,
  pixelStatusUpdateError: null,
  pixelStatusUpdateData: null,
  loadSystemSettingLoading: false,
  loadSystemSettingDone: false,
  loadSystemSettingError: null,
  systemSetting: null,
};

export const NAVER_BATCH_STATUS_UPDATE_REQUEST = 'NAVER_BATCH_STATUS_UPDATE_REQUEST';
export const NAVER_BATCH_STATUS_UPDATE_SUCCESS = 'NAVER_BATCH_STATUS_UPDATE_SUCCESS';
export const NAVER_BATCH_STATUS_UPDATE_FAILURE = 'NAVER_BATCH_STATUS_UPDATE_FAILURE';

export const PIXEL_STATUS_UPDATE_REQUEST = 'PIXEL_STATUS_UPDATE_REQUEST';
export const PIXEL_STATUS_UPDATE_SUCCESS = 'PIXEL_STATUS_UPDATE_SUCCESS';
export const PIXEL_STATUS_UPDATE_FAILURE = 'PIXEL_STATUS_UPDATE_FAILURE';

export const LOAD_SYSTEM_SETTING_REQUEST = 'LOAD_SYSTEM_SETTING_REQUEST';
export const LOAD_SYSTEM_SETTING_SUCCESS = 'LOAD_SYSTEM_SETTING_SUCCESS';
export const LOAD_SYSTEM_SETTING_FAILURE = 'LOAD_SYSTEM_SETTING_FAILURE';

export const UPDATE_SYSTEM_STATUS_RESET = 'UPDATE_SYSTEM_STATUS_RESET';

export const naverBatchStatusUpdateAction = data => ({
  type: NAVER_BATCH_STATUS_UPDATE_REQUEST,
  data,
});

export const pixelStatusUpdateAction = data => ({
  type: PIXEL_STATUS_UPDATE_REQUEST,
  data,
});

export const loadSystemSettingAction = () => ({
  type: LOAD_SYSTEM_SETTING_REQUEST,
});

export const updateSystemStatusResetAction = () => ({
  type: UPDATE_SYSTEM_STATUS_RESET,
});

const reducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case UPDATE_SYSTEM_STATUS_RESET: {
        draft.naverBatchStatusUpdateLoading = false;
        draft.naverBatchStatusUpdateDone = false;
        draft.naverBatchStatusUpdateError = null;
        draft.naverBatchStatusUpdateData = null;
        draft.pixelStatusUpdateLoading = false;
        draft.pixelStatusUpdateDone = false;
        draft.pixelStatusUpdateError = null;
        draft.pixelStatusUpdateData = null;
        break;
      }
      case NAVER_BATCH_STATUS_UPDATE_REQUEST: {
        draft.naverBatchStatusUpdateLoading = true;
        draft.naverBatchStatusUpdateDone = false;
        draft.naverBatchStatusUpdateError = null;
        break;
      }
      case NAVER_BATCH_STATUS_UPDATE_SUCCESS: {
        draft.naverBatchStatusUpdateLoading = false;
        draft.naverBatchStatusUpdateDone = true;
        draft.naverBatchStatusUpdateData = action.data;
        break;
      }
      case NAVER_BATCH_STATUS_UPDATE_FAILURE: {
        draft.naverBatchStatusUpdateLoading = false;
        draft.naverBatchStatusUpdateError = action.error;
        break;
      }
      case PIXEL_STATUS_UPDATE_REQUEST: {
        draft.pixelStatusUpdateLoading = true;
        draft.pixelStatusUpdateDone = false;
        draft.pixelStatusUpdateError = null;
        break;
      }
      case PIXEL_STATUS_UPDATE_SUCCESS: {
        draft.pixelStatusUpdateLoading = false;
        draft.pixelStatusUpdateDone = true;
        draft.pixelStatusUpdateData = action.data;
        break;
      }
      case PIXEL_STATUS_UPDATE_FAILURE: {
        draft.pixelStatusUpdateLoading = false;
        draft.pixelStatusUpdateError = action.error;
        break;
      }
      case LOAD_SYSTEM_SETTING_REQUEST: {
        draft.loadSystemSettingLoading = true;
        draft.loadSystemSettingDone = false;
        draft.loadSystemSettingError = null;
        break;
      }
      case LOAD_SYSTEM_SETTING_SUCCESS: {
        draft.loadSystemSettingLoading = false;
        draft.loadSystemSettingDone = true;
        draft.systemSetting = action.data;
        break;
      }
      case LOAD_SYSTEM_SETTING_FAILURE: {
        draft.loadSystemSettingLoading = false;
        draft.loadSystemSettingError = action.error;
        break;
      }
      default: {
        break;
      }
    }
  });
};

export default reducer;
